import { FC } from 'react';
import Hero from 'src/press/components/Hero';
import ImageSection from 'src/press/components/ImageSection';
import QuotesSection from 'src/press/components/QuotesSection';
import MediaFooter from 'src/press/components/MediaFooter';

const PressRoot: FC = () => (
  <main>
    <Hero />
    <ImageSection />
    <QuotesSection />
    <MediaFooter />
  </main>
);

export default PressRoot;
